import { useState } from "react";
import { motion } from "framer-motion";

export default function FloatingInput({
  id,
  label,
  required = false,
  type = "text",
  value,
  onChange,
  error,
  endAdornment,
  ...rest
}) {
  const [focused, setFocused] = useState(false);
  const floated = focused || (value && value.length > 0);

  const borderColor = error
    ? "border-rose-500/60"
    : focused
    ? "border-[#3652FF]"
    : "border-white/15 hover:border-white/25";

  return (
    <div className="flex flex-col gap-1.5">
      <div className="relative">
        <input
          id={id}
          name={id}
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          className={`peer w-full rounded-md border bg-transparent px-3.5 py-3 text-sm text-white
            outline-none transition-colors duration-200 ${endAdornment ? "pr-11" : ""} ${borderColor}
            ${focused ? "shadow-[0_0_0_3px_rgba(54,82,255,0.15)]" : ""}`}
          {...rest}
        />
        <motion.label
          htmlFor={id}
          initial={false}
          animate={
            floated
              ? { y: "-0.55rem", scale: 0.78 }
              : { y: "0.85rem", scale: 1 }
          }
          transition={{ duration: 0.15, ease: "easeOut" }}
          className={`pointer-events-none absolute left-3 top-0 origin-top-left rounded text-sm transition-colors duration-150
            ${floated ? "bg-[#0B111C] px-1 " + (error ? "text-rose-400" : focused ? "text-[#8CA0FF]" : "text-slate-400") : "px-0 text-slate-500"}`}
        >
          {label}
          {required && <span className="text-[#8CA0FF]"> *</span>}
        </motion.label>

        {endAdornment && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            {endAdornment}
          </div>
        )}
      </div>
      {error && <p className="text-xs font-medium text-rose-400">{error}</p>}
    </div>
  );
}